<script>
import baseMixins from '@/plans/ZOOM_MEETING/config/base.vue';
import { mapState } from 'vuex';
import { isBizPlusContext } from '../common/utils';
import { maxBizAndBizPlusLicenseCount } from '@/common/constants';
export default {
  name: 'ZoomMeetingBuyNow',
  mixins: [baseMixins],
  data() {
    return {
      showPlanDetail: true,
    };
  },
  computed: {
    ...mapState({
      updateBasePlan: state => state.Product.updateBasePlan,
    }),
    licenseAlertDesc() {
      return this.mx_defLicenseAlertDesc;
    },
    showExploreLink() {
      if(isBizPlusContext || this.$context.is.edu) return false;
      return this.form.selectedNumber < maxBizAndBizPlusLicenseCount;
    },
  },
  watch: {
    updateBasePlan: {
      handler(val) {
        val?.update && this.updateForm();
      },
    }
  }
};
</script>
